import * as React from 'react';

var _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgInk = function SvgInk(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 48 48"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#7132F5",
        d: "M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#F0EFFF",
        d: "M24.192 44.952c1.897-.038 3.233-1.362 3.233-2.99 0-1.652-1.301-2.876-2.968-2.876-.839 0-1.219 0-1.599-.016-.375-.016-.749-.047-1.562-.108-1.638-.124-3.022-1.334-3.022-2.99 0-1.653 1.35-2.991 3.021-2.991h3.114c1.667 0 3.017-1.338 3.017-2.99a3.004 3.004 0 0 0-3.017-2.996h-10.23c-1.672 0-3.022-1.338-3.022-2.99 0-1.657 1.35-3 3.021-3H34.47c1.667 0 3.017-1.339 3.017-2.99 0-1.653-1.35-2.991-3.017-2.991H21.296a3.006 3.006 0 0 1-3.022-3c0-1.652 1.536-2.872 3.021-2.99 1.486-.12 1.562-.12 3.114-.12s3.017-1.219 3.017-2.876c0-1.628-1.098-2.951-3.239-2.99H24C12.428 3.048 3.048 12.428 3.048 24c0 11.56 9.362 20.934 20.917 20.952h.227"
    })));
};

export { SvgInk as ReactComponent };
//# sourceMappingURL=INK.svg.es.js.map
